import { db } from "../../firebase";

function getYear() {
  const date = new Date();
  return date.getFullYear();
}

async function backupActivities() {
  const currentYear = getYear();
  // This refers to the volunteering year, so make sure this is correct
  const previousYear = currentYear;

  const activities = await db
    .collection("activities")
    // .limit(10)
    .get()
    .then((v) => v.docs.map((d) => ({ id: d.id, ...d.data() })));

  console.log(
    "Backing up to activites backup",
    previousYear,
    activities.length
  );
  await Promise.all(
    activities.map(async (activity) => {
      console.log("Backing up activity", activity?.id);

      await db
        .collection(`activities-backup-${previousYear}`)
        .doc(activity?.id)
        .set(activity, { merge: true });

      const docSnapshot = await db
        .collection(`activities-backup-${previousYear}`)
        .doc(activity?.id)
        .get();

      if (!docSnapshot.exists) {
        console.error("Failed to backup activity", activity?.id);
        return;
      }

      console.log("Successfully backed up activity", docSnapshot.data());

      console.log("Done backing up activity", activity?.id);
    })
  );
  console.log("Done!");
  console.log(activities);
}

export async function runYearlyResetScript() {
  // Backup all of the past previousYear activities
  await backupActivities()
    .then((r) => {
      console.log(r);
    })
    .catch((e) => {
      console.error(e);
    });

  // Reset all of the hours for all users
}
